import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import ModalFooter from 'app/shared/components/Modal/ModalFooter';

import { ButtonGroup, Button } from '@zillow/constellation';

import ClaimActions from 'app/shared/actions/ClaimActions';

import { MANAGE_CLAIM_METHODS_STEPS } from 'app/shared/components/Modal/ManageClaimContactMethodsModal/constants';

const { VERIFY_CLAIM_CONTACT_TO_DELETE } = MANAGE_CLAIM_METHODS_STEPS;

const propTypes = {
    contactToDelete: PropTypes.object.isRequired,
    currentStep: PropTypes.string.isRequired,
    incrementStep: PropTypes.func.isRequired,
    onDeleteComplete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

const Footer = ({
    contactToDelete,
    currentStep,
    incrementStep,
    onDeleteComplete,
    onClose,
}) => {
    const dispatch = useDispatch();
    const [hasError, setHasError] = React.useState(false);
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const handleRemoveContactMethod = () => {
        setIsSubmitting(true);
        setHasError(false);
        dispatch(ClaimActions.deleteClaimMethod(contactToDelete.type, contactToDelete.value))
            .then(onDeleteComplete)
            .catch(() => setHasError(true))
            .finally(() => setIsSubmitting(false));
    };

    if (currentStep === VERIFY_CLAIM_CONTACT_TO_DELETE) {
        return (
            <ModalFooter
                hasError={hasError}
                isSubmitting={isSubmitting}
                cancelText="Back to Manage Contacts"
                submitText="Remove"
                onCancel={incrementStep}
                onSubmit={handleRemoveContactMethod}
            />
        );
    }
    return (
        <ButtonGroup>
            <Button buttonType="primary" onClick={onClose}>Done</Button>
        </ButtonGroup>
    );
};

Footer.propTypes = propTypes;

export default Footer;
